import { Banner, Link, Text } from '@customerio/pluma-components/react';
import { useBillingAlertBanner } from '../hooks/use-billing-alert-banner';

/**
 * The critical billing-alert banner shared by the billing tabs. Shown when the account is overdue and
 * has a failed lump-sum overage charge or a payment error. Renders nothing otherwise, so a page spaces
 * only the banners that appear.
 */
export function BillingAlertBanner() {
  const model = useBillingAlertBanner();
  if (model == null) {
    return null;
  }

  if (model.kind === 'lump-sum-overage') {
    return (
      <Banner
        variant="critical"
        description={
          <>
            You've exceeded the number of monthly profiles included in your Premium plan.{' '}
            <Link isUnderlined={true} onClick={model.onUpdateBilling}>
              Update your billing information
            </Link>{' '}
            so it includes a valid credit card.
          </>
        }
      />
    );
  }

  return (
    <Banner
      variant="critical"
      description={
        <>
          <Text weight="bold">{model.message}</Text> If you continue to have issues, contact support at{' '}
          <Link href="mailto:billing@customer.io" variant="secondary" isExternal={true}>
            billing@customer.io
          </Link>
          .
        </>
      }
    />
  );
}
